import React from 'react';
import PropTypes from 'prop-types';
import { Job } from './';
import { connect } from 'react-redux';
import * as Actions from 'actions';

class JobList extends React.Component {
  render() {
    const { downloaded_jobs : jobs } = this.props;

    if(!jobs) {
      return <noscript />
    }
    return <div ref='list' className="job-list">
      {jobs.map((job_container, index) =>
        <Job
          onClick={e => {
            if(this.props.onSelect) {
              this.props.onSelect(job_container);
            }
          }}
          key={index}
          job={job_container}
        />
      )}
      <div className="loading">
      {this.props.downloading_jobs ?
        <span><i className="fa fa-spinner fa-spin fa-2x"></i> Loading...</span>
      : 'All downloaded.'}
      </div>
    </div>
  }
}

JobList.propTypes = {
  jobs : PropTypes.array,
  onSelect : PropTypes.func
}

const mapStateToProps = ({jobs}) => ({...jobs});

export default connect(mapStateToProps, Actions)(JobList);



// WEBPACK FOOTER //
// ./src/browser/components/client/jobs/job-list.js